import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
/** A simple styled textarea component.
 * @description Use this element directly wherever a pre-styled textarea element is needed.
 */
@Component({
  selector: 'df-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DfTextareaComponent {
  @Input() public name: string = '';
  @Input() public label: string = '';
  @Input() public placeholder: string = '';
  @Input() public value: string = '';
  @Input() public ariaLabel: string = '';
  @Input() public disabled: boolean = false;
  @Input() public readonly: boolean = false;

  public get placeholderName() {
    return `df-placeholder-${this.name}`;
  }
}
